import { ButtonWithIcon } from '@/components/buttons/buttonWithIcon';
import { Link } from '@/components/shared/link';
import { useRoles } from '@/contexts/useRoles';

export const GoToJobButton = ({
  jobId,
  jobType,
}: {
  jobId: string;
  jobType: 'backup' | 'restore';
}) => {
  const { isAuthorized } = useRoles();
  return (
    <Link
      href={`/jobs/${jobType}?id=${jobId}`}
      disabled={!isAuthorized('read:jobs')}
    >
      <ButtonWithIcon
        disabled={!isAuthorized('read:jobs')}
        text={`Go to ${jobType === 'backup' ? 'Backup' : 'Restore'} Job`}
        icon='material-symbols-arrow-right-alt'
        iconPosition='right'
      />
    </Link>
  );
};
